import { useUI } from '../../context/UIContext'
import { getAssetUrl } from '../../hooks/useAssetUrl'

const TIERS = window.campaignParams?.tiers || [];

const TierButtons = () => {
  const { openModal } = useUI()
  const bgUrl = getAssetUrl('button.webp')

  return (
    <div className="flex flex-row lg:flex-col justify-center items-stretch gap-2 lg:gap-0 w-full lg:max-w-sm mx-auto">
      {TIERS.map((tier) => {
        const donation_amount = tier.monthly_tier * tier.months
        return (
          <div
            key={tier.monthly_tier}
            onClick={() => openModal({ monthly_tier: tier.monthly_tier, months: tier.months, donation_amount })}
            className="flex-1 cursor-pointer transition-transform hover:scale-105"
          >
            {/* ── Mobile View: 3 buttons in a row, red background ── */}
            <div className="flex lg:hidden flex-col text-center justify-center p-2 sm:p-4 bg-[#ef5451] rounded-2xl h-full shadow-sm">
              <p className="text-sm sm:text-base font-medium font-[FbAsli] text-white leading-[1.1]">
                {tier.label}
              </p>
              <div className="flex items-baseline justify-center gap-1 mt-1 sm:mt-2 text-white">
                <span className="text-xl sm:text-2xl font-medium font-[FbAsli] leading-none">
                  {tier.monthly_tier}
                </span>
                <span className="text-xs sm:text-sm font-medium font-[FbAsli] leading-none">
                  ₪ × {tier.months}
                </span>
              </div>
              {tier.sublabel && (
                <span className="mt-1 text-[10px] font-[FbAsli] text-white/90">
                  ({tier.sublabel})
                </span>
              )}
            </div>

            {/* ── Desktop View: Stacked, image background ── */}
            <div 
              className="hidden lg:flex flex-col text-right justify-center pr-9 pt-8 bg-no-repeat bg-center w-[350px] h-[130px] bg-[length:100%_100%]" 
              style={{ backgroundImage: `url(${bgUrl})` }}
            >
              <p className="text-xl sm:text-1xl font-medium font-[FbAsli] text-white leading-[0.7em]">
                {tier.label}
              </p>
              <div className="flex items-baseline gap-1 mt-1 text-white">
                <span className="text-4xl font-medium font-[FbAsli] leading-[0.8em]">
                  {tier.monthly_tier}
                </span>
                <span className="text-2xl font-medium font-[FbAsli] leading-[0.7em]">
                  ₪ × {tier.months}
                </span>
              </div>
              {tier.sublabel && (
                <span className="mt-1 text-xs font-[FbAsli] text-white/90">
                  ({tier.sublabel})
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TierButtons
